import { StoreStockData } from 'common/components/stocks-in-stores/types';

export function hasStock(stocks: StoreStockData[]) {
  return stocks.some((item) => item.stockValue !== 0);
}
